import * as ngCore from '@angular/core'

/**
 * Component for displaying boolean values in table cells
 */
@ngCore.Component({
  selector: 'atn-value-boolean',
  styleUrl: './component.scss',
  templateUrl: './component.html',
})
export class Component {
  /**
   * Boolean value that determines which icon should be shown
   *
   * @see {@link ents.core.common.value.Raw}
   */
  public readonly valueSg = ngCore.input<boolean | undefined>(undefined, {
    alias: 'value',
  })
}
